import { Loader } from 'component/customComponents/loader/loader';
import React, { ReactElement, Suspense, lazy, memo } from 'react';

const LazyCourse = lazy(() =>
  import('./course')
    .then((module) => ({ default: module.Course }))
    .catch(() => {
      document.location.reload();
      return { default: memo(() => <></>) };
    })
);

export const Course = (): ReactElement => (
  <Suspense fallback={<Loader />}>
    <LazyCourse />
  </Suspense>
);
